// extracted by mini-css-extract-plugin
module.exports = {"scorecardNav":"style_scorecardNav__9kUY5","active":"style_active__jo_6t"};